import { apiSlice } from "./apiSlice";

export const merchantApi = apiSlice.injectEndpoints({
    keepUnusedDataFor: 1,
    endpoints: builder => ({
        updateShippingType: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/update-shipping-type`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        //==================Moyasar======================
        createCardToken: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/create-card-token`,
                method: 'POST',
                body: { ...payload }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getCardsTokens: builder.query({
            query: (params) => ({
                url: `/merchant-dashboard/cards`,
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        deleteCardToken: builder.mutation({
            query: (id) => ({
                url: `/merchant-dashboard/card/${id}`,
                method: 'DELETE',
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        selectDefaultCard: builder.mutation({
            query: (id) => ({
                url: `/merchant-dashboard/select-default-card/${id}`,
                method: 'PUT',
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getShippingCompanies: builder.query({
            query: (params) => ({
                url: `/merchant-dashboard/shipping-company`,
                method: 'GET',
                params
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        integrateWithZid: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/zid-integrate`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getZidShippingCompanies: builder.query({
            query: () => ({
                url: `/merchant-dashboard/zid/delivery-options`,
                method: 'GET'
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        assignZidShippingCompanyToMapit: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/zid/delivery-options`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getSallaShippingCompanies: builder.query({
            query: () => ({
                url: `/merchant-dashboard/salla/delivery-options`,
                method: 'GET'
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        assignSallaShippingCompanyToMapit: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/salla/delivery-options`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        integrateWithShopify: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/shopify-integrate`,
                method: 'POST',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getShopifyShippingCompanies: builder.query({
            query: () => ({
                url: `/merchant-dashboard/shopify/delivery-options`,
                method: 'GET'
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        assignShopifyShippingCompanyToMapit: builder.mutation({
            query: (payload) => ({
                url: `/merchant-dashboard/shopify/delivery-options`,
                method: 'PUT',
                body: { ...payload }
            }),
            transformResponse: (response, meta, arg) => response?.body,
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
    })
})

export const {
    useUpdateShippingTypeMutation,
    useCreateCardTokenMutation,
    useGetCardsTokensQuery,
    useDeleteCardTokenMutation,
    useSelectDefaultCardMutation,
    useGetShippingCompaniesQuery,
    useIntegrateWithZidMutation,
    useGetZidShippingCompaniesQuery,
    useAssignZidShippingCompanyToMapitMutation,
    useGetSallaShippingCompaniesQuery,
    useAssignSallaShippingCompanyToMapitMutation,
    useIntegrateWithShopifyMutation,
    useGetShopifyShippingCompaniesQuery,
    useAssignShopifyShippingCompanyToMapitMutation

} = merchantApi